import React from "react";
import PropTypes from "prop-types";

const placeholderImages = [
  "/images/placeholders/retro_tv.webp",
  "/images/placeholders/retro_tower.webp",
  "/images/placeholders/retro_reel.webp",
  "/images/placeholders/retro_projector.webp",
  "/images/placeholders/retro_clapper.webp",
  "/images/placeholders/retro_chair.webp",
];

const PosterPlaceholder = ({ showId, title = "", eyebrow = "", className = "" }) => {
  const placeholderIndex = showId
    ? Math.abs(showId.toString().split("").reduce((a, b) => ((a << 5) - a) + b.charCodeAt(0), 0)) % placeholderImages.length
    : 0;

  return (
    <div className={`poster-placeholder relative flex h-full flex-col items-center justify-center overflow-hidden rounded-md ${className}`}>
      <img
        src={placeholderImages[placeholderIndex]}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-35"
        loading="lazy"
      />
      {(title || eyebrow) && (
        <div className="poster-placeholder__copy">
          {eyebrow && <span className="poster-placeholder__eyebrow">{eyebrow}</span>}
          {title && <span className="poster-placeholder__title">{title}</span>}
        </div>
      )}
    </div>
  );
};

PosterPlaceholder.propTypes = {
  showId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  eyebrow: PropTypes.string,
  className: PropTypes.string,
};

export default PosterPlaceholder;
